module.exports = __webpack_public_path__ + "static/media/icon-paste.2a7c7942.svg";